import { calculate } from '@calculations/price/strategies/fixed-discount/calculate';

import {
  OnQuantityChangeInput,
  OnQuantityChangeOutput,
  OnQuotePriceCreationInput,
  OnQuotePriceCreationOutput,
  RecalculatePriceStrategy,
} from '../types';
import { noOpUnitPrice } from './no-op';

export function onQuantityChange({
  state,
  quoteLine,
  quantity,
}: OnQuantityChangeInput): OnQuantityChangeOutput {
  if (!state.discountCode) {
    return {
      status: 'failure',
      reason: 'No discount code found',
    };
  }

  if (!quoteLine.discountPrices) {
    return {
      status: 'failure',
      reason: 'No discount prices found',
    };
  }

  const output = calculate(
    {
      quantity,
      discountPrices: quoteLine.discountPrices,
      discountCode: state.discountCode,
    },
    state.calculationConfig,
  );

  if (!output) {
    return {
      status: 'failure',
      reason: 'Price calculation failed',
    };
  }

  return {
    status: 'success',
    unitPrice: output.unitPrice,
  };
}

export function onQuotePriceCreation({
  state,
  quoteLine,
  quotePrice,
}: OnQuotePriceCreationInput): OnQuotePriceCreationOutput {
  if (!state.discountCode) {
    return {
      status: 'failure',
      reason: 'No discount code found',
    };
  }

  if (!quoteLine.discountPrices) {
    return {
      status: 'failure',
      reason: 'No discount prices found',
    };
  }

  const output = calculate(
    {
      quantity: quotePrice.quantity,
      discountPrices: quoteLine.discountPrices,
      discountCode: state.discountCode,
    },
    state.calculationConfig,
  );

  if (!output) {
    return {
      status: 'failure',
      reason: 'Price calculation failed',
    };
  }

  return {
    status: 'success',
    quotePrice: {
      ...quotePrice,
      unitPrice: output.unitPrice,
    },
  };
}

export const recalculateFixedDiscount = {
  onQuantityChange,
  onUnitPriceChange: noOpUnitPrice,
  onGrossMarginChange: null,
  onContributionMarginChange: null,
  onBaseGrossMarginChange: null,
  onQuotePriceCreation,
  onUnitCostChange: null,
} satisfies RecalculatePriceStrategy;
